import { OrganizationType } from "@/protocols/organization";

export default {
  appContainerId: "app-container",
  appOrganizationType: process.env
    .REACT_APP_ORGANIZATION_TYPE as OrganizationType,
};
